import tabType5 from "./tabType5";

export default tabType5;
